import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";
import { useParams } from "react-router-dom";
import ViewAppointmentLayer from "../components/ViewAppointmentLayer";
import { API_URL } from "..";
import RemarksRoadmap from "./RemarksRoadMap";

const ViewAppointmentPage = () => {
    const [data,setData]= useState({})
    const [jobRemarks,setJobRemarks]= useState([])
    const {id} = useParams();
    const fetchAppointments = async () => {
        let headerList = {
          "Accept": "*/*",
          "Content-type": "application/json",
        };
        const response = await fetch(
          API_URL+`/api/job/fetch-single/${id}`,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
            setData(data.job)
        }
      };

      const getRemarks = async ()=>{
        // alert(API_URL+'/api/customer/remark/'+id);
        const apiCall = await fetch(API_URL+'/api/customer/remarks/'+id , {method: 'GET', headers:{
          "Accept": "*/*",
        }});
        const response = await apiCall.json();
        if(apiCall.status === 200){
          console.log(response.remarks)
          setJobRemarks(response.remarks.reverse());
        }
      }
      useEffect(()=>{
        fetchAppointments()
        getRemarks()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Job" />
        {
            data.client_name === undefined ? 
            null:
            <>
            <ViewAppointmentLayer data={data} jobRemarks={jobRemarks}/>
            
            
            </>
        }
        
      </MasterLayout>

    </>
  );
};
<style>
  
</style>

export default ViewAppointmentPage; 
